import { render, staticRenderFns } from "./TicketRubrics.vue?vue&type=template&id=58b2bb6f&"
import script from "./TicketRubrics.vue?vue&type=script&lang=js&"
export * from "./TicketRubrics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports